import * as React from "react"
import { classNames } from "../../utils/classNames"

type Props = {
    children: React.ReactNode
    style?: Record<string, any>
    className?: string
}

/**
 * @deprecated - use  '<AgendaHeading />' instead
 */
class AgendaHeadingPanelLegacy extends React.PureComponent<Props> {
    static defaultProps = {
        style: {},
    }

    render() {
        return (
            <div className={classNames("agenda-heading-panel", this.props.className)} style={{ ...this.props.style }}>
                {this.props.children}
                <style jsx={true} global={true}>
                    {`
                        .agenda-heading-panel {
                            border-bottom: 1px solid #e8e8e8;
                            margin-top: 1rem;
                            margin-bottom: 1rem;
                            padding-left: 1rem;
                            padding-right: 1rem;
                            padding-bottom: 1rem;
                        }
                    `}
                </style>
            </div>
        )
    }
}

export default AgendaHeadingPanelLegacy
